import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/AurumHeroContent.js";
import Features from "components/features/ThreeColWithTopImage.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import MainFeature from "components/features/TwoColWithButton.js";
import CaseStudy from "components/testimonials/CaseStudyTextOnly.js";
import FAQ from "components/faqs/SingleCol.js";
// import GetStarted from "components/cta/DownloadApp.js";
import PreFooter from "components/footers/PreFooterBrand.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import StrongBrandImage from "images/aurum_Icons/uiuxImage.svg";
import VideoContentImage from "images/aurum_Icons/aurum-video-library.svg";
import ContentSecurityImage from "images/aurum_Icons/aurum-contentSecurity.svg";
import DevicesImage from "images/aurum_Icons/aurum-devicesImage.svg";
import caseStudyLogoImage from "images/clientLogos/iamsnext.svg";
import caseStudyProfileImage from "images/drsukrit.png"
import Stats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import DesignIllustration from "images/aurum_Icons/heroImg.svg";
import { components } from "ComponentRenderer.js";
import { Helmet } from 'react-helmet';
export default ({
  landingPages = components.landingPages,
  innerPages = components.innerPages,
  }) => {
  const Subheading = tw.p`tracking-widest text-textBlack text-center`;
  const HighlightedText = tw.span`text-primary-500`;
  const VerticalSeprator = tw.div`mt-20 xs:mt-0`;

  return (  
    <>
      <Helmet
      
      title='Unlock the Power of German with Language Pantheon | Yound Minds'
      
      meta={[
        {
          name: 'description',
          content: 'Unlock the Power of German with Language Pantheon German Language Courses with Young Minds',
        },
        {
          property: `og:title`,
          content: 'Unlock the Power of German with Language Pantheon | Young Minds',
        },
        {
          property: `og:description`,
          content: 'Unlock the Power of German with Language Pantheon German Language Courses with Young Minds',
        }]}
    />
      <Hero roundedHeaderButton={true} 
        mainTitle="Unlock the Power of German with Language Pantheon" 
        subTitle="Learn from the Leaders in Goethe Certificate Focused German Language Online Courses with LP & Young Minds"
        buttonText="Let's Talk"
        buttonUrl="https://wa.me/918826622806/?text=Hi, We would like to stream videos with Aurum"
        imageSrc="https://aurumfiles.b-cdn.net/video-streaming-home.png"
        showClient= {true}
      />
      <AnimationRevealPage>
        
        <VerticalSeprator className="v-seperator" />
        <CaseStudy
          imageSrc={caseStudyLogoImage}
          testimonialText = '“The German language online classes we enrolled our students (for PG Medical abroad) in have been extremely helpful. The classes are flexible, tailored to our needs, and the instructors are knowledgeable and professional. We have seen a significant improvement in success rate for admissions in Germany in PG Programs.”'
          profileImageSrc={caseStudyProfileImage}
          customerName="Dr. Sukrit Sharma"
          customerTitle="Founder, CEO, IAMS Next"
          buttonUrl= ""
        />
        <MainFeature
          primaryButtonText="Know More About LP"
          primaryButtonUrl = "https://languagepantheon.com"
          heading="Benefits of Starting Learning German with Language Pantheon "
          description="<ul><li>The Only Institute in India training for All German Language Levels under One Roof.</li><li>100+ Faculty Team, 40+ Countries, 25K+ Successful Learners</li><li>Delivering Engaging Online Live Video Courses globally, for all Levels - A1 to C2.</li><li>Complete Study Abroad Consultancy and Support for Germany</li><li>A Strong Foundation in School Paves way for Easy Success for Studying in Germany. Preparing for German Language Certification in Class 12 along with School Studies is really tough for many students.</li><li>When Your Career is at Stake, Learn from the Industry Leaders. LP is the most powerful brand for serious German Language Learning.</li></ul>"
          subheading="Excellent Faculty Team, Proven Track Record"
          textOnLeft={false}
          imageSrc="https://aurumfiles.b-cdn.net/video-streaming-on-brand-live.png"
          imageBorder={false}
          imageDecoratorBlob={false}
        />
        <MainFeature
          primaryButtonText="Let's Connect"
          primaryButtonUrl = "https://wa.me/918826622806/?text=Hi, We would like to stream videos with Aurum"
          heading="Focused on Globally Recognised Goethe Certifications & CBSE Boards"
          description="<ul><li>Language Pantheon is Exclusively Focused on German Language Certifications and CBSE Curriculum.</li><li>LP Offers Guarantee Programs for All Levels of German Certification Exams - A1 to C2.</li><li>Enabling Learners Qualify Goethe Certifications in Shortest Time.</li><li>Well Researched Curated Contents and Interactive Exam Preparation for CBSE / School Studies.</li><li><b>Immersive Learning Methodology</b> where students are placed in a real-world environment where they must use the language in order to communicate and solve problems.</li></ul>"
          subheading=""
          imageSrc="https://aurumfiles.b-cdn.net/video-streaming-recording.png"
          imageBorder={false}
          imageDecoratorBlob={false}
        />
        <Stats/>
        
        
        <FAQ
          subheading={<Subheading></Subheading>}
          description={'Video Streaming - Devices, Flexibility & Security'}
          heading={
            <>
              Frequently Asked Questions
            </>
          }
          faqs={[
            {
              question: "What makes this system different from other German language learning systems?",
              answer:
                "This system is unique because it provides a comprehensive syllabus with a focus on practical learning rather than memorization. The institute only teaches German and offers a high success rate for students who take the exam."
            },
            {
              question: "Why should I join this institute for German language learning?",
              answer:
                "You should join here if you are looking for a system that is committed to ensuring your success in learning German. The teachers are knowledgeable and dedicated to helping students achieve their goals. This institute has a proven track record of success for more than 15 Years."
            },
            
            {
              question: "What kind of commitment can I expect from this institute?",
              answer:
                "This institute provides a moral and legal commitment to ensure that students are taken through the entire syllabus until they receive their certificate. The institute believes that the student's success is their success, and they take this commitment seriously."
            },
            {
              question: "What is the impact of Video Quality on User Experience ?",
              answer:
                "Higher the Quality of the Video i.e. SD, HD or FULL HD, higher will be file size per hour. So if file size of 1 Hr of Video is 500 MB or 1 GB, it directly impacts the <b>Speed of the Broadband / Internet Required</b> by User other wise video will buffer."
            },
            {
              question: "Who can/should join these courses ?",
              answer:
                "Students aspiring for global careers, interested in pursuing studies abroad or are looking to learn something that might be helpful at a later stage, must opt for German Language Course."
            }
          ]}
        />
        <PreFooter formheading="Streaming Videos Live and VOD Amplifies Your Business & Growth" formsubheading="Book Our Free Discussion Session Today - " heightlightText="How to Start Streaming and Grow Video Business"/>
      </AnimationRevealPage>
      <Footer />
   </>
  );
}
